import { useContext } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MyContext } from "../../Context/MyContext";
import classes from "./AboutUs.module.css";
import site from "../../data/site";

export default function AboutUs() {
  const { aboutUsRef } = useContext(MyContext);

  return (
    <section ref={aboutUsRef} className={`sectionShell ${classes.section}`} id="about">
      <Container>
        <div className={classes.grid}>
          <div className={classes.media}>
            <img
              src={site.about.image}
              alt={site.about.imageAlt}
              width={site.about.width}
              height={site.about.height}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className={classes.copy}>
            <div className="sectionEyebrow">About</div>
            <h2 className="sectionTitle">A studio built to help you ship</h2>
            <p>
              DigitaliNation is a software and marketing studio founded by{" "}
              {site.founder}. We are a fully remote team based in Islamabad,
              Pakistan, working with clients worldwide.
            </p>
            <p>
              We pair engineering with growth work so businesses get more than
              a deliverable — they get a partner who stays until the numbers
              move.
            </p>
            <p>
              From web and mobile products to social, email, design, AI
              automations, GoHighLevel, and virtual assistance, we tailor the
              work to the problem in front of you.
            </p>
            <p>
              <Link to="/about">More about the studio</Link>
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
